import { INewbuildingLayoutOffer } from '../../types/newbuildingBookedOfferLayouts/newbuildingLayoutOffer';

export enum ENewbuildingBookedOfferLayoutsActionTypes {
  SetBookedOfferLayouts = 'bookedOfferLayouts/set',
}

export interface ISetBookedOfferLayoutsAction {
  type: ENewbuildingBookedOfferLayoutsActionTypes.SetBookedOfferLayouts;
  payload: INewbuildingLayoutOffer[];
}

export type TNewbuildingBookedOfferLayoutsActions = ISetBookedOfferLayoutsAction;

/* istanbul ignore next */
export const setBookedOfferLayouts = (layouts: INewbuildingLayoutOffer[]): ISetBookedOfferLayoutsAction => ({
  type: ENewbuildingBookedOfferLayoutsActionTypes.SetBookedOfferLayouts,
  payload: layouts,
});
